import { InitialValues, ValidationErrors } from 'forms/types';
import { isPresent } from 'forms/validators';

import { BenefitPeriodFormValues } from '../form/types';

export const validate = ({
  benefitPeriod,
}: InitialValues<BenefitPeriodFormValues>): ValidationErrors<BenefitPeriodFormValues> => ({
  benefitPeriod: isPresent(benefitPeriod),
});
